import React from 'react';

export type Pillar = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

export function PillarCard({ pillar }: { pillar: Pillar }) {
  return (
    <li className="pillar-card">
      <div className="pillar-card__icon" aria-hidden="true">
        {pillar.icon}
      </div>
      <h3 className="pillar-card__title">{pillar.title}</h3>
      <p className="pillar-card__desc">{pillar.description}</p>
    </li>
  );
}
